import { useEffect, useRef } from "react";

/**
 * Returns a ref to attach to an Alert element.
 * Scrolls to it whenever `message` becomes truthy.
 * Works for both error and success messages.
 *
 * Usage:
 *   const alertRef = useScrollToAlert(error);
 *   <Alert ref={alertRef} message={error} />
 *
 *   // Or for success:
 *   const successRef = useScrollToAlert(successMsg);
 *   <Alert ref={successRef} message={successMsg} variant="success" />
 */
export default function useScrollToAlert(message) {
  const ref = useRef(null);

  useEffect(() => {
    if (message && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [message]);

  return ref;
}

